const InfoIcon = ({ width = '24', height = '24', className = '', color = 'currentColor' }) => {
    return (
        <svg height={height} width={width} className={className} viewBox="0 0 12 12">
            <path
                d="M6 0c3.308 0 6 2.692 6 6s-2.692 6-6 6-6-2.692-6-6 2.692-6 6-6zm0 .75A5.257 5.257 0 00.75 6 5.257 5.257 0 006 11.25 5.257 5.257 0 0011.25 6 5.257 5.257 0 006 .75zm.577 4.525V9.4H5.452V5.275h1.125zM6.015 4.15a.75.75 0 100-1.5.75.75 0 000 1.5z"
                fill={color}
                fillRule="evenodd"
            />
        </svg>
    )
}
export default InfoIcon
